import React, { useState, useEffect } from "react";
import { Bars3Icon } from "@heroicons/react/24/outline";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faUserCircle, faCaretDown } from "@fortawesome/free-solid-svg-icons"; 
import { Outlet, useNavigate } from "react-router-dom";
import logo from './Images/passionit.png'; 
import { Link } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';
import EditProfile from '../UserCommon/editprofile';
import '../UserCommon/usercommon.css';

const User = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userId, setUserId] = useState('');
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [masterDropdownOpen, setMasterDropdownOpen] = useState(false);
  const [languageDropdownOpen, setlanguageDropdownOpen] = useState(false); 
  const [playGameDropdownOpen, setPlayGameDropdownOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    
    if (token) {
      const decoded = jwtDecode(token);
      const userId = parseInt(decoded.id, 10);
      setUserId(userId);
      localStorage.setItem("id", userId);
      setEmail(decoded.email);
      
      if (!isLoggedIn) {
        setIsLoggedIn(true);
        if (!sessionStorage.getItem("hasReloaded")) {
          sessionStorage.setItem("hasReloaded", "true"); 
          window.location.reload(); 
        }
      }
    } else {
      setIsLoggedIn(false);
      sessionStorage.removeItem("hasReloaded"); 
    }
  }, []);    

  useEffect(() => {
    const loadGoogleTranslate = () => {
      if (!window.googleTranslateElementInit) {
        window.googleTranslateElementInit = function () {
          new window.google.translate.TranslateElement(
            { pageLanguage: "en", autoDisplay: true },
            "google_translate_element"
          );
        };
  
        const scriptId = "google-translate-script";
        let script = document.getElementById(scriptId);
  
        if (!script) {
          script = document.createElement("script");
          script.id = scriptId;
          script.type = "text/javascript";
          script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
          script.async = true;
          document.body.appendChild(script);
        } else {
          window.googleTranslateElementInit(); 
        }
      } else {
        window.googleTranslateElementInit(); 
      }
    };
  
    if (isLoggedIn) {
      loadGoogleTranslate(); 
    }
  }, [isLoggedIn]); 
  
  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    localStorage.removeItem("id");
    navigate("/login");
  };

  const handleProfileClick = () => {
    setProfileMenuOpen(!profileMenuOpen);
    console.log("Profile button clicked, new state:", !profileMenuOpen);
  };
  
  const handleMasterDropdownToggle = () => {
    setMasterDropdownOpen(!masterDropdownOpen);
    console.log("Master dropdown clicked, new state:", !masterDropdownOpen);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".profile-menu, .profile-button")) {
        setProfileMenuOpen(false);
      }
      if (!e.target.closest(".master-dropdown, .master-button")) {
        setMasterDropdownOpen(false);
      }
      if (!e.target.closest(".language-dropdown, .language-button")) {
        setlanguageDropdownOpen(false);
      }
      if (!e.target.closest(".playgame-dropdown, .playgame-button")) {
        setPlayGameDropdownOpen(false);
      }      
    };
  
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []); 
  
  const handlePlayGameDropdownToggle = () => {
    setPlayGameDropdownOpen(!playGameDropdownOpen);
  };

  return (
    <>
      <div className="sticky top-0 bg-[#e64a32] z-50 py-4">
        <nav>
          <div className="mx-auto max-w-7xl">
            <div className="flex justify-between items-center mx-auto w-full">
              {/* Logo on the left */}
              <Link to="/" className="flex items-center">
                <img src={logo} alt="Passion IT Logo" className="h-10 w-auto" />
              </Link>

              <div className="flex flex-col lg:flex-row justify-start items-center w-full gap-10 px-4 py-2"> 
                <Link to="/" className="mr-2 text-white">Home</Link>

                {/* Play DB Button */}
                <div className="relative playgame-dropdown">
                <button
                  onClick={handlePlayGameDropdownToggle}
                  className="text-white flex items-center gap-2 playgame-button"
                >

                Explore Games
                <FontAwesomeIcon
                  icon={faCaretDown}
                  className={`transition-transform ${playGameDropdownOpen ? 'rotate-180' : ''}`}
                />
              </button>

          {playGameDropdownOpen && (
            <div className="absolute bg-white text-gray-800 shadow-lg rounded-md mt-2 w-56 z-50">
              <Link to="/playdbtable" className="block px-4 py-2 hover:bg-gray-200">
                PassionIT PRUTL Game
              </Link>
              <Link to="/chakramaster" className="block px-4 py-2 hover:bg-gray-200">
                Chakra Game
              </Link>
             <Link to="/cubegame" className="block px-4 py-2 hover:bg-gray-200">
              Cube Game
            </Link>
            <Link to="/africangame" className="block px-4 py-2 hover:bg-gray-200">
                A Game
            </Link>
            <Link to="/dattagame" className="block px-4 py-2 hover:bg-gray-200">
                D Game
            </Link>
            <Link to="/sikhgame" className="block px-4 py-2 hover:bg-gray-200">
                K Game
            </Link>
            <Link to="/torahgame" className="block px-4 py-2 hover:bg-gray-200">
                T Game
            </Link>
            <Link to="/crossgame" className="block px-4 py-2 hover:bg-gray-200">
              X Game
            </Link>
            <Link to="/yingyanggame" className="block px-4 py-2 hover:bg-gray-200">
              Y Game
            </Link>
            <Link to="/zorogame" className="block px-4 py-2 hover:bg-gray-200">
              Z Game
            </Link>

            </div>
          )}
        </div>

               {/* Language Dropdown */}
               <div id="google_translate_element"></div>

                {/* Master Dropdown Menu */}
                <div className="relative master-dropdown order-1">
                  <button
                    onClick={handleMasterDropdownToggle}
                    className="text-white mr-6 flex items-center gap-2"
                  >
                    Master
                    <FontAwesomeIcon
                      icon={faCaretDown} // Dropdown arrow icon
                      className={`transition-transform ${masterDropdownOpen ? 'rotate-180' : ''}`}
                    />
                  </button>
                  {masterDropdownOpen && (
                    <div className="absolute bg-white text-gray-800 shadow-lg rounded-md mt-2 w-48 z-50">
                      <Link to="/dashboard" className="block px-4 py-2 hover:bg-gray-200">Games Dashboard</Link>
                      <Link to="/categorytable" className="block px-4 py-2 hover:bg-gray-200">Game Category</Link>
                      <Link to="/cardgrouptable" className="block px-4 py-2 hover:bg-gray-200">Card Group</Link>
                      <Link to="/cardtable" className="block px-4 py-2 hover:bg-gray-200">Card</Link>
                      <Link to="/gamemastertable" className="block px-4 py-2 hover:bg-gray-200">Game Master</Link>
                      <Link to="/cardalloctable" className="block px-4 py-2 hover:bg-gray-200">Game Card Allocation</Link>
                      <Link to="/chakragametable" className="block px-4 py-2 hover:bg-gray-200">Chakra Game Data</Link>
                      <Link to="/vajrachakratable" className="block px-4 py-2 hover:bg-gray-200">Vajrachakra Data</Link>
                      <Link to="/chariottable" className="block px-4 py-2 hover:bg-gray-200">Chariot Table Data</Link>
                      <Link to="/cubemaster" className="block px-4 py-2 hover:bg-gray-200">Cube Game Data</Link>
                      <Link to="/networktable" className="block px-4 py-2 hover:bg-gray-200">Network Management</Link>
                      <Link to="/history" className="block px-4 py-2 hover:bg-gray-200">Game History</Link>
                    </div>
                  )}
                </div>
              </div>

              <div className="flex items-center gap-4">
          <div className="flex items-center lg:hidden">
            <button onClick={() => setToggleMenu(!toggleMenu)}>
              <Bars3Icon className="h-6" />
            </button>
          </div>
          {isLoggedIn && (
      <div className="relative flex items-center profile-menu order-2">
      <button
      onClick={handleProfileClick}
      className="flex items-center text-white hover:text-gray-300 focus:outline-none profile-button"
    >
      <FontAwesomeIcon icon={faUserCircle} className="h-6" />
      <span className="ml-4 text-white">Profile</span>
    </button>
    {profileMenuOpen && (
  <div className="absolute right-0 mt-2 bg-white rounded-md shadow-lg z-50 w-78">
    <div className="px-4 py-2 text-gray-600">
      <p className="font-semibold">Profile</p>
      <p className="text-gray-600">{email}</p>
      
      {/* Edit Profile Button */}
            <div className="text-gray-800 hover:bg-gray-200">
            <Link to="/editprofile" className="block px-4 py-2">Edit Profile</Link></div>

      {/* Log Out Button */}
      <button
        onClick={handleLogout}
        className="mt-2 w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-200"
      >
        <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
        Log Out
      </button>
        </div>
      </div>
    )}
  </div>
)}
        </div>
            </div>
          </div>
        </nav>
      </div>

      {toggleMenu && (
        <div className="flex flex-col items-center gap-4 mt-4 lg:hidden">
          <Link to="/" className="mr-2 text-white" onClick={() => setToggleMenu(false)}>Home</Link>
          <Link to="/playdbtable" className="mr-2 text-white" onClick={() => setToggleMenu(false)}>Play DB</Link> {/* Play DB for mobile */}
          <Link to="/cardgrouptable" className="mr-2 text-white" onClick={() => setToggleMenu(false)}>Card Group</Link>
          <Link to="/cardtable" className="mr-6 text-white" onClick={() => setToggleMenu(false)}>Card</Link>
          <Link to="/categorytable" className="mr-6 text-white" onClick={() => setToggleMenu(false)}>Game Category</Link>
          <Link to="/gamemastertable" className="mr-6 text-white" onClick={() => setToggleMenu(false)}>Game Master</Link>
          <Link to="/cardalloctable" className="mr-6 text-white" onClick={() => setToggleMenu(false)}>Game Card Allocation</Link>
          <Link to="/chakragametable" className="mr-6 text-white" onClick={() => setToggleMenu(false)}>Chakra Game Data</Link>
          <Link to="/cubemaster" className="mr-6 text-white" onClick={() => setToggleMenu(false)}>Cube Game Data</Link>
          <Link to="/networktable" className="mr-6 text-white" onClick={() => setToggleMenu(false)}>Network Management</Link>
          <Link to="/history" className="mr-6 text-white" onClick={() => setToggleMenu(false)}>Game History</Link>
  
        </div>
      )}

      <div className="py-10 px-2">
        <Outlet />
      </div>
    </>
  );
};

export default User;
